export default {
  setColor: color => {
    document.documentElement.style.setProperty('--primary-color', color);
  }
}